import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import * as XLSX from 'xlsx';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
interface Target {
  I_FinancialYear_ID: number;
  I_State_Code: number;
  I_Activity_ID: number;
  I_PT: number;
  I_FT: number;
}
interface ExtendedTarget extends Target {
  I_District_Code: number;
  I_Crop_Code: number;
}

@Component({
  selector: 'app-physical-fin-target',
  templateUrl: './physical-fin-target.component.html',
  styleUrls: ['./physical-fin-target.component.scss']
})
export class PhysicalFinTargetComponent implements OnInit {

  statePhyFinanceForm: FormGroup;
  districtPhyFinanceForm: FormGroup;
  statePhyFinanceData: Target[] = [];
  districtPhyFinanceData: any = [];

  blockSpace: RegExp = /^[^\s,]([^,]*[^\s,])?$/; 

  public showStateFinStatus: boolean = false;
  public getStatePhyFinanceData: any = [];
  public showDistrictFinStatus: boolean = false;
  public getDistrictPhyFinanceData: any = [];
  public showDistrictAchievementDataStatus: boolean = false;
  public getDistrictPhyAchievementData: any = [];
  public showDistrictOSAchievementDataStatus: boolean = false;
  public getDistrictOSAchievementData: any = [];

  xslxToJsonData: any[] = [];
  uploadFile: any;

  constructor(
    private fb: FormBuilder,
    private fApplicationService: FarmersDetailsService,
    private loader: AppLoaderService,
    private messageService: MessageService,
    ) {}

  ngOnInit(): void {
    this.statePhyFinanceForm = this.fb.group({
      I_FinancialYear_ID: [null, [Validators.required, Validators.pattern(/^\d+$/)]],
      I_State_Code: [null, [Validators.required, Validators.pattern(/^\d+$/)]],
      I_Activity_ID: [null, [Validators.required, Validators.pattern(/^\d+$/)]],
      I_PT: [null, [Validators.required, Validators.min(0)]],
      I_FT: [null, [Validators.required, Validators.min(0)]]
    });

    this.districtPhyFinanceForm = this.fb.group({
      I_FinancialYear_ID: [null, [Validators.required, Validators.pattern(/^\d+$/)]],
      I_State_Code: [null, [Validators.required, Validators.pattern(/^\d+$/)]],
      I_District_Code: [null, [Validators.required, Validators.pattern(/^\d+$/)]],
      I_Activity_ID: [null, [Validators.required, Validators.pattern(/^\d+$/)]],
      I_Crop_Code: [null, [Validators.required, Validators.pattern(/^\d+$/)]],
      I_PT: [null, [Validators.required, Validators.min(0)]],
      I_FT: [null, [Validators.required, Validators.min(0)]]
    });
  }
  

  addStatePhyFinanceData() {
    if (this.statePhyFinanceForm.valid) {
      this.statePhyFinanceData.push(this.statePhyFinanceForm.value);
      this.statePhyFinanceForm.reset();
    } else {
      this.statePhyFinanceForm.markAllAsTouched();
    }

  }

  addDistPhyFinanceData() {
    if (this.districtPhyFinanceForm.valid) {
      this.districtPhyFinanceData.push(this.districtPhyFinanceForm.value);
      this.districtPhyFinanceForm.reset();
    } else {
      this.districtPhyFinanceForm.markAllAsTouched();
    }
  }

  deleteStatePhyTarget(index: number) {
    this.statePhyFinanceData.splice(index, 1);
  }

  deleteDistPhyTarget(index: number) {
    this.districtPhyFinanceData.splice(index, 1);
  }



  // state target
  onSubmitStatePhyTarDate() {
    // Handle target form submission    
    let reqBody = this.statePhyFinanceData;
    this.insertStatePhysicalFinData(reqBody);
  }

  insertStatePhysicalFinData(reqBody){
    this.loader.start();
    this.fApplicationService 
      .insertStatePhysicalFinancialTarget(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
         
          if(res.Success == true){
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: res.Message,
            });
            this.statePhyFinanceData = [];
            this.statePhyFinanceForm.reset();
          }else{
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: res.Message,
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onClickGetStateTarData(){
    this.showStateFinStatus = true;
    this.getStateFinTargetData();
  }

  getStateFinTargetData(){
    this.loader.start();
    this.fApplicationService 
      .getStatePhysicalFinancialTarget()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
         
          if(res.length > 0){
            this.getStatePhyFinanceData = res;
          }else{
            this.getStatePhyFinanceData = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Found',
            });
          }
        },
        error: (err) => {
          this.getStatePhyFinanceData = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSubmitStateFinData(){
    this.loader.start();
    this.fApplicationService 
      .postStatePhysicalFinancialTarget()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
         
          if(res['6'] == "Test Data Inserted Sucessfully"){
            this.showStateFinStatus = false;
            this.getStatePhyFinanceData = [];
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: res['6'],
            });
          }else{
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Saved',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }


  // district target
  onSubmitDistrictPhyTarDate() {
    // Handle extended target form submission
    let reqBody = this.districtPhyFinanceData;
    this.insertDistrictPhysicalFinData(reqBody);
  }

  insertDistrictPhysicalFinData(reqBody){
    this.loader.start();
    this.fApplicationService 
      .insertDistrictPhysicalFinancialTarget(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
         
          if(res.Success == true){
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: res.Message,
            });
            this.districtPhyFinanceData = [];
            this.districtPhyFinanceForm.reset();
          }else{
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: res.Message,
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onClickDistrictTarData(){
    this.showDistrictFinStatus = true;
    this.getDistrictFinTargetData();
  }

  getDistrictFinTargetData(){
    this.loader.start();
    this.fApplicationService 
      .getDistrictPhysicalFinancialTarget()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
         
          if(res.length > 0){
            this.getDistrictPhyFinanceData = res;
          }else{
            this.getDistrictPhyFinanceData = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Found',
            });
          }
        },
        error: (err) => {
          this.getDistrictPhyFinanceData = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSubmitDistrictFinData(){
    this.loader.start();
    this.fApplicationService 
      .postDistrictPhysicalFinancialTarget()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
  
          if(res['6'] == "Test Data Inserted Successfully"){
            this.getDistrictPhyFinanceData = [];
            this.showDistrictFinStatus = false;
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: res['6'],
            });
          }else if('Error' in res){
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: res['Error'],
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  // district achievement
  onClickDistrictAchieveData(){
    this.showDistrictAchievementDataStatus = true;
    this.getDistrictFinAchievementData();
  }

  getDistrictFinAchievementData(){
    this.loader.start();
    this.fApplicationService 
      .getDistrictPhysicalFinancialAchievement()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
         
          if(res.length > 0){
            this.getDistrictPhyAchievementData = res;
          }else{
            this.getDistrictPhyAchievementData = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Found',
            });
          }
        },
        error: (err) => {
          this.getDistrictPhyAchievementData = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSubmitDistrictFinAchievementData(){
    this.loader.start();
    this.fApplicationService 
      .postDistrictPhysicalFinancialAchievement()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
         
          // if(res.length > 0){
          //   this.getStatePhyFinanceData = res;
          // }else{
          //   this.getStatePhyFinanceData = [];
          //   this.messageService.add({
          //     severity: 'info',
          //     summary: 'Info Message',
          //     detail: 'Data Not Found',
          //   });
          // }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  // district other source achievement
  onClickDistrictOSAchieveData(){
    this.showDistrictOSAchievementDataStatus = true;
    this.getDistrictFinOSAchievementData();
  }

  getDistrictFinOSAchievementData(){
    this.loader.start();
    this.fApplicationService 
      .getDistrictOtherSourceAchievement()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
         
          if(res.length > 0){
            this.getDistrictOSAchievementData = res;
          }else{
            this.getDistrictOSAchievementData = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Found',
            });
          }
        },
        error: (err) => {
          this.getDistrictOSAchievementData = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSubmitDistrictOSAchievementData(){
    this.loader.start();
    this.fApplicationService 
      .postDistrictOtherSourceAchievement()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();         
          // if(res.length > 0){
          //   this.getStatePhyFinanceData = res;
          // }else{
          //   this.getStatePhyFinanceData = [];
          //   this.messageService.add({
          //     severity: 'info',
          //     summary: 'Info Message',
          //     detail: 'Data Not Found',
          //   });
          // }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }


  // upload state fin target
  onUploadStateFinDetails(event, formcontrol, uploadElement) {
    this.uploadFile = [];
    let workBook = null;
    let jsonData = null;
    let sheetName = null
    const reader = new FileReader();
    let file = event.files[0];
    this.uploadFile = file;
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary', cellText:false, cellDates:true });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        sheetName = name;
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet, {
          raw: true,
          dateNF:'yyyy-mm-dd',
        });
        return initial;
      }, {});
      const dataString = JSON.stringify(jsonData);
      let statePhyFinData = JSON.parse(dataString)[sheetName];
      // this.xslxToJsonDataPersonal = JSON.parse(dataString)[sheetName];
      // if (!(this.xslxToJsonDataPersonal)) {
      if (!(statePhyFinData)) {
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'The Uploaded file has invalid data "or" Multiple sheet data is not supported!' });
      // }else if(this.xslxToJsonDataPersonal.length == 0){
      }else if(statePhyFinData.length == 0){
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'The Uploaded file is empty!' });
      }else{
        this.addUploadedStateData(statePhyFinData);
      }
    }
    reader.readAsBinaryString(file);
    uploadElement.clear();
  }

  addUploadedStateData(value){
    this.statePhyFinanceData = value.map((val) => ({
      'I_FinancialYear_ID': val?.['Financial Year'] ,
      'I_State_Code': val?.['State Code'] ,
      'I_Activity_ID': val?.['Activity Id'] ,
      'I_PT': val?.['PT'] ,
      'I_FT': val?.['FT']
    }))
  }

  clearStateUploadData(){
    this.statePhyFinanceData = [];
  }


  // upload state fin target
  onUploadDistrictFinDetails(event, formcontrol, uploadElement) {
    this.uploadFile = [];
    let workBook = null;
    let jsonData = null;
    let sheetName = null
    const reader = new FileReader();
    let file = event.files[0];
    this.uploadFile = file;
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary', cellText:false, cellDates:true });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        sheetName = name;
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet, {
          raw: true,
          dateNF:'yyyy-mm-dd',
        });
        return initial;
      }, {});
      const dataString = JSON.stringify(jsonData);
      let districtPhyFinData = JSON.parse(dataString)[sheetName];
      if (!(districtPhyFinData)) {
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'The Uploaded file has invalid data "or" Multiple sheet data is not supported!' });
      }else if(districtPhyFinData.length == 0){
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'The Uploaded file is empty!' });
      }else{
        this.addUploadedDistrictData(districtPhyFinData);
      }
    }
    reader.readAsBinaryString(file);
    uploadElement.clear();
  }

  addUploadedDistrictData(value){
    this.districtPhyFinanceData = value.map((val) => ({
      'I_FinancialYear_ID': val?.['Financial Year'] ,
      'I_State_Code': val?.['State Code'] ,
      'I_District_Code': val?.['District Code'],
      'I_Activity_ID': val?.['Activity Id'] ,
      'I_Crop_Code': val?.['Crop Id'] ,
      'I_PT': val?.['PT'] ,
      'I_FT': val?.['FT']
    }))
  }

  clearDistrictUploadData(){
    this.districtPhyFinanceData = [];
  }

}
